<template>
  <div id="tablePage">
    <!-- 交收列表查询 (选货查询)-->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="交易品种"
        >
        </el-table-column>
        <el-table-column
          prop="ChBsFlag"
          label="方向"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="storageName"
          label="仓库"
          min-width="150"
        >
        </el-table-column> -->
        <el-table-column
          prop="quantity"
          label="数量"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="weight"
          label="总重量"
        >
        </el-table-column> -->
        <el-table-column
          prop="sellQuantity"
          label="可选数量"
        >
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template v-if="Number(scope.row.sellQuantity)>0" slot-scope="scope">
            <span style="cursor:pointer;color:#2382fa" @click="gettingData(scope.row)">申请</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <applayXh ref="applyList" :type="2" @getData="getFiData" />
  </div>
</template>
<script>
/*global http */
import applayXh from './applayXh'
import protocolSS from '../protocol/protocolSS'
export default {
  components: {
    applayXh
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['symbolId', 'bsFlag', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      popupBtn: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      isNetWrong: false
    }
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    protocolSS.param_getSelection.param.sort = [
      {
        direction: 'DESC',
        property: 'tsgCreateTime'
      }
    ]
    this.showData()
  },
  methods: {
    getFiData() {
      this.pageData.currentPage = 1
      this.showData()
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      this.loading = true
      protocolSS.param_getSelection.param.page = this.pageData.currentPage - 1
      protocolSS.param_getSelection.param.size = '' + this.pageData.pageSize
      protocolSS.param_getSelection.param.commodityId = this.symbolId
      protocolSS.param_getSelection.param.bsFlag = this.bsFlag
      http.postFront2(protocolSS.param_getSelection).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.each(arr, function(arrIndex) {
              arrIndex.ChBsFlag = arrIndex.bsFlag === 'B' ? '买' : '卖'
            })
            this.tableData = arr
          }
        }
        this.loading = false
      })
    },
    gettingData(obj) {
      // 显示弹窗
      this.$refs.applyList.showDialog(obj)
    }

  }

}
</script>

